import React, { memo } from 'react'
import PropTypes from 'prop-types'

import Product from 'components/Product'
import MoneyUnit from 'components/MoneyUnit'
import { MACHINE_TYPES } from 'constants/machines'

function AssignedProduct({ className, cost, empty, machineType, productType }) {
  return (
    <div className={`assigned-product assigned-product--${machineType} ${className}`}>
      <div className="assigned-product__box">
        {!empty && (
          <>
            <Product product={{ name: productType }} imgClassName="assigned-product__icon" />
            <div className="assigned-product__cost">
              <MoneyUnit coins={cost} />
            </div>
          </>
        )}
      </div>
      <div className="assigned-product__foot" />
    </div>
  )
}

AssignedProduct.propTypes = {
  className: PropTypes.string.isRequired,
  cost: PropTypes.number.isRequired,
  empty: PropTypes.bool,
  machineType: PropTypes.oneOf(Object.entries(MACHINE_TYPES).map(([key, value]) => value))
    .isRequired,
  productType: PropTypes.string.isRequired
}

AssignedProduct.defaultProps = {
  empty: false
}

export default memo(AssignedProduct)
